import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const HeroSection = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="hero-section">
      <div className="hero-content">
        <div className="hero-text">
          <h1 className="hero-headline">
            Transform Your Body.<br />
            Reclaim Your Strength.
          </h1>
          <p className="hero-subheadline">
            10+ years of proven expertise in customized training programs. 
            Whether you're recovering from injury, building strength, or transforming your physique — 
            get personalized coaching backed by science and real results.
          </p>
          <div className="hero-cta-group">
            <Link to="/schedule" className="btn-cta">
              Start Your Transformation
              <ArrowRight size={20} style={{ marginLeft: '8px' }} />
            </Link>
            <Link to="/schedule" className="btn-secondary">
              Free Consultation
            </Link>
          </div>
          <div className="hero-credentials">
            <div className="credential-item">
              <span className="credential-number">10+</span>
              <span className="credential-label">Years Experience</span>
            </div>
            <div className="credential-item">
              <span className="credential-number">500+</span>
              <span className="credential-label">Clients Trained</span>
            </div>
            <div className="credential-item">
              <span className="credential-number">ISSA</span>
              <span className="credential-label">Certified</span>
            </div>
          </div>
        </div>
        <div className="hero-image">
          <img 
            src="https://images.unsplash.com/photo-1648542036561-e1d66a5ae2b1" 
            alt="Professional trainer working with client"
            loading="eager"
          />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
